module.exports = __webpack_public_path__ + "img/cndef-loader.2cd04019.gif";